module.exports = __webpack_public_path__ + "static/media/united-kingdom.e2132738.png";